import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { untypedIsEnabled } from '@ip-only/client-features';
import { filter, map, take } from 'rxjs/operators';
import { isGlobalConnectFinland } from './shared/utils/communication-operator.util';

@Component({
  selector: 'app-root',
  template: `
    <app-hub-sidebar></app-hub-sidebar>

    <div class="main">
      <gc-snackbars-container></gc-snackbars-container>

      <app-navbar></app-navbar>

      <main class="main__content">
        <router-outlet></router-outlet>
      </main>

      @if (routerLoaded() && footerEnabled) {
      <app-footer></app-footer>
      }
    </div>
  `,
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);

  readonly footerEnabled = untypedIsEnabled('footer');

  readonly routerLoaded = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      take(1),
      map(() => true)
    ),
    { initialValue: false }
  );

  constructor(private documentTitleService: Title) {}

  ngOnInit(): void {
    if (isGlobalConnectFinland()) {
      this.documentTitleService.setTitle('Palveluvalikoima');
    } else {
      this.documentTitleService.setTitle('Självbetjäningsportal');
    }
  }
}
